module.exports = __webpack_public_path__ + "img/sjksh.56e2d50f.png";